import lodash from 'lodash'
import React, { ReactElement, useCallback, useEffect } from 'react'

import useFieldJumper from './useFieldJumper'

export type TFieldJumperProps = {
  containerRef: HTMLDivElement
}

const FieldJumper = (props: TFieldJumperProps): ReactElement => {
  const { containerRef } = props

  const { isDisabled } = useFieldJumper()

  // console.log('FIELD JUMPER IS ', isDisabled ? 'DISABLED' : 'ENABLED')

  const onEnter = useCallback((): void => {
    if (isDisabled) {
      // console.log('Skipping enter, Field jumper is disabled')
      return
    }
    const currentElement = document.activeElement
    // console.log('FieldJumper onEnter', currentElement)
    if (
      !containerRef ||
      !currentElement ||
      lodash.toLower(currentElement.tagName) !== 'input'
    ) {
      // console.log(
      //   "Not able to jump... containerRef.current doesn't exist or currentElement is not an input or currentElement is undefined",
      //   { containerRef, currentElement },
      // )
      return
    }
    try {
      // TODO: introduce className "jump-target" to jump to fields other than input
      const inputElements: NodeListOf<Element> = containerRef.querySelectorAll(
        'input, .jump-target',
      )
      // const inputElements = containerRef.current.getElementsByClassName(
      //   "jump-target"
      // )
      let target
      let pastCurrent = false
      // eslint-disable-next-line no-restricted-syntax
      for (const element of Array.from(inputElements)) {
        // console.log('Jump through elements')
        if (element === currentElement) {
          pastCurrent = true
          // eslint-disable-next-line no-continue
          continue
        }
        if (
          pastCurrent &&
          (element.classList.contains('form-control') ||
            element.classList.contains('jump-target'))
        ) {
          target = element
          break
        }
      }
      if (target) {
        // console.log('next target is', target)
        target.focus()
      }
      // eslint-disable-next-line no-empty
    } catch (err) {}
  }, [isDisabled, containerRef])

  const onKeyPress = (e): void => {
    if (e.keyCode === 13) {
      onEnter()
    }
  }

  useEffect(() => {
    window.addEventListener('keypress', onKeyPress)

    return () => {
      window.removeEventListener('keypress', onKeyPress)
    }
  }, [isDisabled, containerRef])

  return <></>
}

export default FieldJumper
